export const voices = [
  {
    name: '林见山',
    title: '媒体观察者',
    text: '17爆料网最难得的是把“传闻”和“事实”分开放。同一件事，它会把已经核实的部分和还在打听的部分标得清清楚楚，这在流量时代真的少见。',
    theme: 'primary',
  },
  {
    name: '苏晚',
    title: '五年的老读者',
    text: '我喜欢它用时间线讲事情的方式。很多热点在别处看得云里雾里，在这里按时间排一遍，前因后果立刻清楚，不用再自己东拼西凑。',
    theme: 'accent',
  },
  {
    name: '陈亦舟',
    title: '科技行业从业者',
    text: '科技内幕栏目的数据拆解挺扎实，供应链和产品节奏的分析看得出是做过功课的，不是简单复述发布会上的说法。',
    theme: 'secondary',
  },
  {
    name: '周知遥',
    title: '民生话题关注者',
    text: '民生观察那几个小区加装电梯的样本写得很实在，没有煽情，就是把推进到哪一步、卡在哪里讲明白，读起来很有收获。',
    theme: 'secondary',
  },
];